import { lazy, Suspense } from 'react'

const BundledEditor = lazy(() => import('./BundledEditor'))

interface WysiwygEditorProps {
  initialValue: string
  onInit: (evt: any, editor: any) => void
  onChange: () => void
}

export function WysiwygEditor({
  initialValue,
  onInit,
  onChange
}: WysiwygEditorProps) {
  return (
    <div className="flex-1 min-w-0">
      <Suspense
        fallback={
          <div className="h-[700px] bg-white rounded border border-gray-300 flex items-center justify-center">
            <p className="text-gray-500">Loading editor...</p>
          </div>
        }
      >
        <BundledEditor
          onInit={onInit}
          initialValue={initialValue}
          init={{
            height: 700,
            menubar: true,
            skin: false,
            content_css: false,
            iframe_aria_text: 'HTML editor (visual)',
            plugins: [
              'advlist',
              'anchor',
              'autolink',
              'charmap',
              'code',
              'codesample',
              'directionality',
              'emoticons',
              'fullscreen',
              'help',
              'image',
              'insertdatetime',
              'link',
              'lists',
              'media',
              'nonbreaking',
              'pagebreak',
              'preview',
              'save',
              'searchreplace',
              'table',
              'visualblocks',
              'wordcount'
            ],
            toolbar1:
              'undo redo | blocks | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat',
            toolbar2:
              'link image media table | charmap emoticons hr pagebreak | insertdatetime | preview fullscreen code codesample | print save',
            image_advtab: true,
            content_style:
              'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
          }}
          onEditorChange={onChange}
          onKeyUp={onChange}
        />
      </Suspense>
    </div>
  )
}
